class Location {

    constructor(props) {
        Object.assign(this, props);
    }

}

export { Location };